

































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PaymentTimeoutModalComponent extends Vue {
  public $refs!: {
    modal: any;
  };

  @Prop(String) public readonly id!: string;

  private reset() {
    this.$emit('reset');
  }

  private close() {
    this.reset();
    this.$refs.modal.hide();
  }
}
